'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _icon = require('./view/icon.js');

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _icon2['default'];
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/@alicd/next/lib/_components/@alicd/next-icon/lib/index.js
// module id = 77
// module chunks = 0